<!-- <header class="header">
  <div class="header-left">
     <img src="assets/img/logo.png" alt="Logo Órgano Judicial" class="logo"> 
    <h5>Envío Masivo de Correos.</h5>
  </div>
</header> -->
<div class="content-header">
    <h2>Envío Masivo de Correos.</h2>
</div>
@if(loading){
<div class="loading-overlay">
  <div class="loading-indicator">Enviando correos masivos...</div>
</div>
}
<div class="container-fluid">
  <div class="justify-content-center min-vh-100 bg-light p-3">
    <div class="excel-container">
      <oaj-alert-itx></oaj-alert-itx>

      <!-- Sección de captura de identificadores -->
       @if(!mostrarResultados){
      <div>
        <div class="card shadow-sm" style="width: 100%;">
          <div class="card-body">
            <label class="form-label mb-1" for="idOrganismo">Identificador de Organismo</label>
            <div class="d-flex align-items-center gap-2 flex-wrap">
              <input 
                type="number" 
                id="idOrganismo"
                class="form-control" 
                placeholder="Ingrese el ID del organismo"
                [(ngModel)]="nuevoIdOrganismo"
                (keyup.enter)="agregarIdOrganismo()"
                min="1"
                style="width: 300px;">
              <button 
                class="btn btn-envio"
                (click)="agregarIdOrganismo()">
                <i class="fas fa-plus"></i> Agregar ID
              </button>
              <button 
                class="btn btn-envio"
                (click)="cargarDesdeExcel()"
                title="Cargar IDs desde archivo Excel">
                <i class="fas fa-file-excel"></i> Cargar desde Excel
              </button>
              <button 
                class="btn btn-envio"
                (click)="limpiarLista()"
                [disabled]="idsOrganismos.length === 0">
                <i class="fas fa-trash"></i> Limpiar Lista
              </button>
            </div>

            <div class="aviso-frame mt-3">
              <i class="fas fa-info-circle"></i>
              Ingrese los identificadores de los organismos a los que desea enviar correos. 
              Puede presionar <strong>Enter</strong> para agregar cada ID rápidamente, o 
              <strong>cargar un archivo Excel</strong> con los identificadores en la columna A.
            </div>
          </div>
        </div>

        @if(idsOrganismos.length > 0) {
        <div class="row mt-3">
          <div class="col-md-6">
            <label for="searchId" class="form-label">Buscar ID:</label>
            <input 
              type="text" 
              id="searchId"
              class="form-control" 
              placeholder="Buscar por ID..."
              [(ngModel)]="searchText"
              style="max-width: 300px;">
          </div>
          <div class="col-md-6 text-end">
            <label for="searchId" class="form-label">Total de IDs capturados:</label>
            <h3 class="titulo">{{ idsOrganismos.length }}</h3>
          </div>
        </div>

        <div class="row mt-3">
          <div class="table-container">
            <table>
              <thead>
                <tr>
                  <th width="80">#</th>
                  <th>ID Organismo</th>
                  <th width="120" class="text-center">Acciones</th>
                </tr>
              </thead>
              <tbody>
                @if(idsFiltrados.length === 0) {
                <tr>
                  <td colspan="3" class="text-center text-muted">
                    No se encontraron IDs que coincidan con la búsqueda
                  </td>
                </tr>
                }
                @for(id of idsFiltrados; track $index; let i = $index) {
                <tr>
                  <td>{{ i + 1 }}</td>
                  <td><strong>{{ id }}</strong></td>
                  <td class="text-center">
                    <button 
                      class="btn btn-envio btn-sm"
                      (click)="eliminarIdOrganismo(id)"
                      title="Eliminar ID">
                      <i class="fas fa-trash"></i>
                    </button>
                  </td>
                </tr>
                }
              </tbody>
            </table>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-12 text-end">
            <button 
              class="btn btn-login"
              (click)="enviarCorreosMasivos()"
              [disabled]="loading || idsOrganismos.length === 0">
              <i class="fas fa-paper-plane"></i> 
              Enviar Correos Masivos ({{ idsOrganismos.length }})
            </button>
          </div>
        </div>
        }
      </div>
    }
      <!-- Sección de resultados -->
       @if(mostrarResultados){
      <div>
        <!-- Tarjetas de resumen -->
        <div class="row mb-3">
          <div class="col-md-4">
            <div class="stats-card stats-primary">
              <i class="fas fa-clipboard-list"></i>
              <div>
                <h3>{{ totalProcesados }}</h3>
                <p>Total Procesados</p>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="stats-card stats-success">
              <i class="fas fa-check-circle"></i>
              <div>
                <h3>{{ totalEnviados }}</h3>
                <p>Enviados Exitosamente</p>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="stats-card stats-danger">
              <i class="fas fa-exclamation-triangle"></i>
              <div>
                <h3>{{ totalErrores }}</h3>
                <p>Errores</p>
              </div>
            </div>
          </div>
        </div>

        <!-- Tabla de resultados detallados -->
        <div class="row mt-3">
          <div class="col-12">
            <div class="d-flex justify-content-between align-items-center mb-3">
              <h3 class="titulo">Resultados Detallados</h3>
              <div>
                <button 
                  class="btn btn-login me-2"
                  (click)="exportarResultadosExcel()">
                  <i class="fas fa-file-excel"></i> Exportar a Excel
                </button>
                <button 
                  class="btn btn-envio"
                  (click)="resetear()">
                  <i class="fas fa-arrow-left"></i> Nuevo Envío
                </button>
              </div>
            </div>
            <div class="mb-3">
              <input 
                type="text" 
                class="form-control" 
                placeholder="Buscar en resultados..."
                [(ngModel)]="searchText"
                style="max-width: 300px;">
            </div>

            <div class="table-container">
              <table>
              <thead>
                <tr>
                  <th>ID Organismo</th>
                  <th>Nombre Organismo</th>
                  <th>Correo</th>
                  <th width="120" class="text-center">Estado</th>
                  <th>Mensaje Error</th>
                </tr>
              </thead>
              <tbody>
                @if(resultadosFiltrados.length === 0) {
                <tr>
                  <td colspan="5" class="text-center text-muted">
                    No se encontraron resultados
                  </td>
                </tr>
                }
                @for(resultado of resultadosFiltrados; track $index) {
                <tr>
                  <td>{{ resultado.idOrganismo }}</td>
                  <td>{{ resultado.nombreOrganismo }}</td>
                  <td>{{ resultado.correo }}</td>
                  <td class="text-center">
                    <span class="badge" [ngClass]="resultado.enviado ? 'badge-success' : 'badge-danger'">
                      <i [class]="resultado.enviado ? 'fas fa-check' : 'fas fa-times'"></i>
                      {{ resultado.enviado ? 'Enviado' : 'Error' }}
                    </span>
                  </td>
                  <td>
                    <span [class.text-danger]="!resultado.enviado">
                      {{ resultado.mensajeError || 'N/A' }}
                    </span>
                  </td>
                </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
}
  </div>
</div>
